/** Public community / feedback channel (web client). */
export const PEYPHONE_FEEDBACK_CHANNEL_URL =
  "https://web.peyphone.com/channel/01K4WTVKWD7FTG8YREX9TN8DDC";
